<div class="w-full" (click)="setFocus()">
	<ui-rich-text-editor-toolbar
		(redo)="onRedo()"
		(undo)="onUndo()"
		[id]="'rich-text-editor-toolbar-' + editorId()"
	></ui-rich-text-editor-toolbar>

	<quill-editor
		(onEditorCreated)="editorCreated($event)"
		[modules]="quillConfig()"
		class="ui-rich-text-editor__editor bg-standard w-full"
		(onContentChanged)="contentChanged($event)"
		[placeholder]="placeholder()"
		(onFocus)="setFocus()"
		(focusout)="focusOut()"
		[ngClass]="{ 'is-focused': focused() }"
	>
	</quill-editor>
</div>
